import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import type RetryWorkflowStep from '@Application/WorkflowRuns/Retry/Commands/RetryWorkflowStep';
import workflowStepRetried, {
	type WorkflowStepRetriedAction,
} from '@Application/WorkflowRuns/Retry/Actions/workflowStepRetried';
import workflowStepRetryFailed, {
	type WorkflowStepRetryFailedAction,
} from '@Application/WorkflowRuns/Retry/Actions/workflowStepRetryFailed';
import type { WorkflowRunPayload } from '@Application/WorkflowRuns/WorkflowRun/Actions/workflowRunFetched';
import { post } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = WorkflowStepRetriedAction | WorkflowStepRetryFailedAction;

export default (command: RetryWorkflowStep) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await post<WorkflowRunPayload>(
				`${buildSubjectApiPath(command.facilityId, command.subject)}/workflow-runs/${command.runId}/steps/${command.stepId}/retries`,
				{},
			);

			const action = workflowStepRetried(
				payload,
				command.facilityId,
				command.subject.typeKey,
				command.subject.subjectId,
			);
			dispatch(action);
			return action;
		} catch (error) {
			const action = workflowStepRetryFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
